document.addEventListener("DOMContentLoaded", function () {
  const slides = document.querySelectorAll(".home-hero-slider .slide");
  if (!slides.length) return;

  let currentIndex = 0;
  const interval = 5000;

  function showSlide(index) {
    slides.forEach((slide, i) => {
      slide.classList.toggle("active", i === index);
    });
  }

  function goToNextSlide() {
    currentIndex = (currentIndex + 1) % slides.length;
    showSlide(currentIndex);
  }

  showSlide(currentIndex); // Show first slide
  setInterval(goToNextSlide, interval);
});
